import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Restaurantoversigt',
  tabs: {
    [Tab.OngoingOrders]: 'Tilbered nu',
    [Tab.FutureOrders]: 'Kommende',
    [Tab.CompleteOrders]: 'Afsluttet',
  },
  buttons: {
    order_history: 'Ordrehistorik',
  },
  feedback: {
    future_orders_alert: '⚠️ Start ikke tilberedning endnu – vi giver besked, når du skal starte.',
  },
};
